import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const groupLabel = css`
  display: block;
  font-size: ${theme.fontSize(16)};
  line-height: 1.35;
  margin-bottom: ${theme.spacing(2)};
`;
